import { render, staticRenderFns } from "./Snapshots.vue?vue&type=template&id=7d514290&scoped=true"
import script from "./Snapshots.vue?vue&type=script&lang=js"
export * from "./Snapshots.vue?vue&type=script&lang=js"
import style0 from "./Snapshots.vue?vue&type=style&index=0&id=7d514290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d514290",
  null
  
)

export default component.exports